/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {
  useState, useEffect, useRef,
} from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import styled from '@emotion/styled';
import ResizeObserver from 'react-resize-observer';
import { Field } from 'formik';
import IcomoonReact from 'icomoon-react';
import { useTheme } from 'emotion-theming';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import Input from '../../../../shared/_TBComponents/Input/index';
import ExerciseVideoSection from './ExerciseVideoSection';
import SelectBox from '../../../../shared/_TBComponents/SelectBox/index';
import { setActiveSecondLayerModal, fetchDocument, addAsset } from '../../ducks/calendarActions';
import { showErrorToast } from '../../../../shared/utils/toastManager';
import useDisplayedDocumentAsset from './hooks/useDisplayedDocumentAsset';

const DescriptionContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const CircuitsInputsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const AdditionalOptionsHeaderRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const AdditionalOptionsTextAndArrowIconContainer = styled('div')`
 display: flex;
 align-items: center;
 cursor: pointer;
 gap: 8px;
 transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const Seperator = styled('div')`
  display: flex;
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.borderLight};
`;

const CircuitsInputsRow = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.containerWidth < 528 ? 'column' : 'row')};
  gap: 32px;
`;

const CircuitsInputsSubContainer = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

const InputTypeAndPRTrackingContainer = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.containerWidth < 840 ? 'column' : 'row')};
  gap: 16px;
`;

const OuterLinkContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

const StyledTextArea = styled('textarea')`
  width: 100%;
  height: 100%;
  min-height: 82px !important;
  padding: 10px;
  font-size: 16px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  font-family: 'Nunito Sans';
  color: ${({ theme }) => theme.colors.text};
  background: ${({ theme }) => theme.colors.surfaceInput};
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.hover};
    box-shadow: none;
  }
  ::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  :disabled {
    background: ${({ theme }) => theme.colors.surface};
    border-color: ${({ theme }) => theme.colors.borderLight};
    color: ${({ theme }) => theme.colors.textTertiary};
  }
`;

const AddAssetButtonContainer = styled('div')`
  display: flex;
  gap: 4px;
  cursor: pointer;
  align-items: center;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const AssetButtonContainer = styled('div')`
  position: relative;
  display: flex;
  gap: 4px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  cursor: pointer;
  align-items: center;
  border-radius: 4px;
  width: fit-content;
`;

const ClearAssetIconContainer = styled('div')`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${({ theme }) => theme.colors.borderMedium};
  padding: 4px;
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const NameAndInputContainer = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  .checkbox-input {
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid ${({ theme }) => theme.colors.borderMedium};
    border-radius: 4px;
    outline: none;
   cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
    position: relative;
    transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
  }

  .checkbox-input:checked {
    border: ${(props) => (props.disabled ? `2px solid ${props.theme.colors.borderMedium}` : `2px solid ${props.theme.colors.hover}`)};
   }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: ${(props) => (props.disabled ? `solid ${props.theme.colors.borderMedium}` : `solid ${props.theme.colors.hover}`)};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }
`;

const CheckBoxRow = styled('div')`
 display: flex;
 flex-wrap: wrap;
 gap: 16px;
`;

const LabelAndCheckBoxContainerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const AdditionalOptionsWrapper = styled('div')`
  display: flex;
  gap: 16px;
  margin-top: -9px;
  transition: ${TransitionGlobal};
  overflow: hidden;
  max-height: ${(props) => (!props.showAdditionalOptions ? '0px' : '500px')};
`;

const AddAssetsColumn = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const CompleteContainer = styled('div')`
  display: flex;
  align-items: flex-end;
  width: 100%;
  input {
    border-bottom-left-radius: 0px !important;
    border-top-left-radius: 0px !important;
    border-color: ${(props) => !!props.touched && props.error && '#CC0404'};
  }
`;

const CompleteContainerAndErrorWrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-end;
`;

const ExerciseManagementWarning = styled('div')`
  display: flex;
  gap: 12px;
  background: ${({ theme }) => theme.colors.warningSurface};
  border: 1px solid ${({ theme }) => theme.colors.warningBorder};
  border-radius: 8px;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 11px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.warningText};
  p {
    font-size: 9pt;
  }
`;

const WarningAndInputContainer = styled('div')`
display: flex;
flex-direction: column;
`;

const IconContainer = styled('div')`
display: flex;
min-width: 16px;
`;

const CircuitsFormInputs = ({
  errors,
  touched,
  handleChange,
  mediaType,
  videoUrlValue,
  mediaUrlValue,
  mediaIdValue,
  trackingValue,
  linkToValue,
  setFieldValue,
  handleBlur,
  setFieldTouched,
  setFieldError,
  urlButtonValue,
  containerWidth,
  coachCompletionValue,
  setTouched,
  prSortOrderValue,
  trackValue,
  reusableItemValue,
  detailValue,
  inputTypeValue,
  detailTypeValue,
  hasExerciseManagementAccess,
  documentId,
  documentUrl,
  unifiedVideoFlow = false,
  isManageExercisesContext = false,
}) => {
  const dispatch = useDispatch();
  const assetToAdd = useSelector((state) => state.calendar.data.addAsset);
  const { displayedAsset, canClear } = useDisplayedDocumentAsset(documentId, documentUrl, assetToAdd);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const accountCode = currentUser?.accountCode;
  const modalData = useSelector((state) => state.calendar.data.modalData);
  const { colors } = useTheme();
  const [showAdditionalOptions, setShowAdditionalOptions] = useState(true);
  const [addAssetsColumnContainerWidth, setAddAssetsColumnContainerWidth] = useState(0);
  const detailByInputTypeRef = useRef({ [inputTypeValue]: detailValue });

  useEffect(() => {
    if (assetToAdd) {
      setFieldValue('documentId', assetToAdd?.id);
    }
  }, [assetToAdd]);

  const inputTypeOptions = [
    {
      name: 'Sets',
      id: 'S',
      includeCheckmark: inputTypeValue === 'S',
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Reps',
      id: 'R',
      includeCheckmark: inputTypeValue === 'R',
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Time',
      id: 'T',
      includeCheckmark: inputTypeValue === 'T',
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'None (Completion)',
      id: 'C',
      includeCheckmark: inputTypeValue === 'C',
      checkmarkColor: colors.textTertiary,
    },
  ];

  const detailTypeOptions = [
    {
      name: 'Sets',
      id: 'sets',
      includeCheckmark: inputTypeValue === 'sets',
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Reps',
      id: 'reps',
      includeCheckmark: inputTypeValue === 'reps',
      checkmarkColor: colors.textTertiary,
    },
  ];

  const AthleteInputCheckBoxDataArray = [
    {
      name: 'coachCompletion',
      label: 'Coach Completion',
      checked: coachCompletionValue,
    },
  ];

  const showOnLeaderboard = trackValue > 0;

  const customSelectStylesLinkTo = {
    control: (provided, state) => ({
      ...provided,
      borderTopRightRadius: state.options.some((option) => option.id === 'sets') && '0px',
      borderBottomRightRadius: state.options.some((option) => option.id === 'sets') && '0px',
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 400,
      background: state.options.some((option) => option.id === 'sets') ? colors.surfaceSecondary : colors.surface,
      borderColor: state.isFocused ? colors.hover : colors.borderLight,
      boxShadow: state.isFocused ? 'none' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? colors.hover : colors.borderLight,
      },
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '8px 12px',
      backgroundColor: state.isSelected ? colors.surfaceSecondary : colors.surfaceElevated,
      color: state.isSelected || ((linkToValue === 'none' || linkToValue === null) && state.data.id === 'none') || (trackingValue === 0 && state.data.id === 0) ? colors.textTertiary : colors.text,
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: state.data.__isNew__ ? 700 : 400,
      '&:hover': {
        backgroundColor: colors.surfaceSecondary,
      },
      paddingLeft: state.data.isGrouped && '12px',
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: colors.surfaceSecondary,
      border: `1px solid ${colors.borderLight}`,
      borderRadius: '4px',
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: colors.text,
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: colors.textSecondary,
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: colors.surfaceElevated,
      color: colors.text,
      border: '0px',
      minWidth: '250px',
      padding: '4px 0',
      marginTop: '0px',
      marginBottom: '0px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '500px',
    }),
    group: (provided) => ({
      ...provided,
      padding: '0px',
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontSize: '16px',
      fontWeight: 700,
      color: colors.textSecondary,
      paddingLeft: '0px',
      paddingRight: '0px',
      marginBottom: '8px',
      fontFamily: 'Nunito Sans',
      textTransform: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: colors.textSecondary,
    }),
    input: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? 'inherit' : provided.color, /** Use 'inherit' to maintain original color */
    }),
  };

  return (
    <CircuitsInputsContainer>
      <CircuitsInputsRow containerWidth={containerWidth}>
        <ExerciseVideoSection
          errors={errors}
          touched={touched}
          mediaType={mediaType}
          videoUrlValue={videoUrlValue}
          mediaUrlValue={mediaUrlValue}
          mediaIdValue={mediaIdValue}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          setFieldError={setFieldError}
          containerWidth={containerWidth}
          isDisabled={modalData?.disabledEditModal}
          urlButtonValue={urlButtonValue}
          unifiedVideoFlow={unifiedVideoFlow}
        />
        <CircuitsInputsSubContainer>
          <WarningAndInputContainer>
            {!hasExerciseManagementAccess && !modalData?.disabledEditModal && (
            <ExerciseManagementWarning>
              <IconContainer>
                <IcomoonReact
                  iconSet={iconSet}
                  size={16}
                  icon='warning'
                  color='#F59E0B'
                />
              </IconContainer>
              <Text>You do not have the user permissions required to save to the exercise database.</Text>
            </ExerciseManagementWarning>
            )}
            {!isManageExercisesContext && (
            <NameAndInputContainer disabled={modalData?.disabledEditModal || !hasExerciseManagementAccess}>
              <input
                disabled={modalData?.disabledEditModal || !hasExerciseManagementAccess}
                className='checkbox-input'
                type='checkbox'
                name='reusableItem'
                onChange={() => {
                  setFieldValue('reusableItem', !reusableItemValue);
                  /** if the user goes to uncheck save to database we need to set
                 * prSortOrder value back to 0 if there is one and we need to hide
                 * prSortOrder as an input option
                 */
                  if (reusableItemValue) {
                    setFieldValue('prSortOrder', 0);
                    setFieldValue('track', 0);
                  }
                }}
                checked={reusableItemValue}
              />
              <Text color={(modalData?.disabledEditModal || !hasExerciseManagementAccess) && colors.textTertiary} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>Save to Database</Text>
            </NameAndInputContainer>
            )}
          </WarningAndInputContainer>
          <OuterLinkContainer>
            <InputTypeAndPRTrackingContainer containerWidth={containerWidth}>
              <SelectBox
                isDisabled={modalData?.disabledEditModal}
                options={inputTypeOptions}
                value={inputTypeOptions.find((option) => option.id === inputTypeValue)}
                onChangeFunction={(option) => {
                  detailByInputTypeRef.current[inputTypeValue] = detailValue;
                  setFieldValue('inputType', option.id);
                  /** clear prSortOrder */
                  setFieldValue('prSortOrder', 0);
                  setFieldValue('track', 0);
                  if (option.id === 'C' || option.id === 'T') {
                    setFieldValue('detailType', 'sets');
                    setFieldValue('detail', detailByInputTypeRef.current[option.id] ?? 0);
                  } else {
                    setFieldValue('detailType', null);
                    setFieldValue('detail', detailByInputTypeRef.current[option.id] ?? '');
                  }
                }}
                onBlur={() => setFieldTouched('inputType', true)}
                error={!!touched.inputType && !!errors.inputType}
                errorMsg={errors.inputType}
                title='Input Type'
                titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                customStyles={customSelectStylesLinkTo}
                isClearable={false}
                styledProps={{ height: '' }}
                width='100%'
                styledPropsInput={{
                  width: '100% !important',
                }}
              />
              {(inputTypeValue === 'R' || inputTypeValue === 'S') ? (
                <Input
                  disabled={modalData?.disabledEditModal}
                  error={!!touched.detail && !!errors.detail}
                  errorMsg={errors.detail}
                  fontSize='16px'
                  fontWeight={400}
                  height='38px'
                  label='Time Limit'
                  name='detail'
                  onChange={(value) => {
                    handleChange(value);
                    setTouched({ detail: true });
                  }}
                  onBlur={handleBlur}
                  right='5px'
                  styledPropsLabel={{
                    fontSize: '16px',
                    fontWeight: 700,
                  }}
                  styledPropsWrapper={{
                    /** flex: 1, */
                  }}
                  top='38px'
                  value={detailValue}
                  width='100%'
                  placeholder={(inputTypeValue === 'R' || inputTypeValue === 'S') && '00:00'}
                />
              ) : (
                <CompleteContainerAndErrorWrapper>
                  <Text color={modalData?.disabledEditModal && colors.textTertiary} fontSize='16px' fontWeight={700}>{inputTypeValue === 'T' ? `Complete ${detailTypeValue} for time` : 'Complete'}</Text>
                  <CompleteContainer touched={touched.detail} error={errors.detail}>
                    <SelectBox
                      isDisabled={modalData?.disabledEditModal}
                      removeSeparator
                      options={detailTypeOptions}
                      value={detailTypeOptions.find((option) => option.id === detailTypeValue)}
                      onChangeFunction={(option) => {
                        setFieldValue('detailType', option.id);
                      }}
                      onBlur={() => setFieldTouched('detailType', true)}
                      error={!!touched.detailType && !!errors.detailType}
                      errorMsg={errors.detailType}
                      titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                      customStyles={customSelectStylesLinkTo}
                      isClearable={false}
                      styledProps={{ height: '' }}
                      styledPropsInput={{
                        width: '100px !important',
                      }}
                      width='100px'
                    />
                    <Input
                      disabled={modalData?.disabledEditModal}
                      fontSize='16px'
                      fontWeight={400}
                      height='38px'
                      name='detail'
                      onChange={(value) => {
                        handleChange(value);
                        setTouched({ detail: true });
                      }}
                      onBlur={handleBlur}
                      right='5px'
                      styledPropsLabel={{
                        fontSize: '16px',
                        fontWeight: 700,
                      }}
                      styledPropsWrapper={{
                        flex: 1,
                      }}
                      top='38px'
                      value={detailValue || ''}
                      width='100%'
                      placeholder={(inputTypeValue === 'R' || inputTypeValue === 'S') && '00:00'}
                    />
                  </CompleteContainer>
                  {!!touched.detail && !!errors.detail && (
                  <Text fontSize='13px' fontWeight={700} color='#CC0404' style={{ marginTop: '5px' }}>{errors.detail}</Text>
                  )}
                </CompleteContainerAndErrorWrapper>
              )}
            </InputTypeAndPRTrackingContainer>
          </OuterLinkContainer>
          {((inputTypeValue === 'R' && !!reusableItemValue) || (inputTypeValue === 'S' && !!reusableItemValue) || (inputTypeValue === 'T' && !!reusableItemValue)) && (
          <NameAndInputContainer disabled={modalData?.disabledEditModal || !hasExerciseManagementAccess}>
            <input
              disabled={modalData?.disabledEditModal || !hasExerciseManagementAccess}
              className='checkbox-input'
              type='checkbox'
              name='showOnLeaderboard'
              onChange={() => {
                if (showOnLeaderboard) {
                  setFieldValue('track', 0);
                } else {
                  setFieldValue('track', 1);
                  if (!(prSortOrderValue > 0)) {
                    setFieldValue('prSortOrder', 1);
                  }
                }
              }}
              checked={showOnLeaderboard}
            />
            <Text color={(modalData?.disabledEditModal || !hasExerciseManagementAccess) && colors.textTertiary} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>Show on leaderboard</Text>
          </NameAndInputContainer>
          )}
          <DescriptionContainer>
            <Text
              fontSize='16px'
              fontWeight={700}
              color={modalData?.disabledEditModal && colors.textTertiary}
            >
              Description
            </Text>
            <Field
              name='description'
              className='form-control'
              render={({ field }) => (
                <StyledTextArea disabled={modalData?.disabledEditModal} {...field} />
              )}
            />
            {errors.description && (
            <Text color='#CC0404' fontSize='13px' fontWeight={700} style={{ marginTop: '5px' }}>{errors.description}</Text>
            )}
          </DescriptionContainer>
          <AddAssetsColumn>
            <ResizeObserver
              onResize={(rect) => {
                setAddAssetsColumnContainerWidth(rect?.width);
              }}
            />
            {modalData?.disabledEditModal ? null : (
              <Text fontSize='16px' fontWeight={700}>Attach Document/Link</Text>
            )}
            {displayedAsset ? (
              <AssetButtonContainer onClick={() => {
                const docId = displayedAsset?.id;
                if (displayedAsset.type === 1) {
                  dispatch(fetchDocument(({ accountCode, docId }), {
                    onSuccess: (response) => {
                      window.open(response?.url, '_blank');
                    },
                    onError: () => {
                      showErrorToast('Opps! Something went wrong. Unable to fetch document.');
                    },
                  }));
                }
                if (displayedAsset.type === 2) {
                  window.open(displayedAsset?.url, '_blank');
                }
              }}
              >
                {canClear && (
                  <ClearAssetIconContainer onClick={(e) => {
                    dispatch(addAsset(null));
                    setFieldValue('documentId', 0);
                    setFieldValue('documentUrl', null);
                    e.stopPropagation();
                  }}
                  >
                    <IcomoonReact
                      iconSet={iconSet}
                      size={10}
                      icon='remove'
                      color={colors.textSecondary}
                    />
                  </ClearAssetIconContainer>
                )}
                <IcomoonReact
                  iconSet={iconSet}
                  size={14}
                  icon='link'
                  color={colors.textSecondary}
                />
                <Text
                  style={{
                    maxWidth: `${addAssetsColumnContainerWidth - 60}px`,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                  fontSize='16px'
                  color={colors.textSecondary}
                >
                  {displayedAsset?.name}
                </Text>
              </AssetButtonContainer>
            ) : (
              <>
                {!modalData?.disabledEditModal && (
                <AddAssetButtonContainer onClick={() => dispatch(setActiveSecondLayerModal('addAssetModal'))}>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={12}
                    icon='plus'
                    color={colors.hover}
                  />
                  <Text fontSize='16px' color={colors.hover}>Add Asset</Text>
                </AddAssetButtonContainer>
                )}
              </>
            )}
          </AddAssetsColumn>
        </CircuitsInputsSubContainer>
      </CircuitsInputsRow>
      <AdditionalOptionsHeaderRow>
        <Seperator />
        <AdditionalOptionsTextAndArrowIconContainer onClick={() => setShowAdditionalOptions(!showAdditionalOptions)}>
          <Text fontSize='18px' color={colors.textSecondary} style={{ minWidth: '210px' }}>Exercise Default Settings</Text>
          <IcomoonReact
            iconSet={iconSet}
            size={8}
            icon={showAdditionalOptions ? 'up-arrow' : 'down-arrow'}
            color={colors.textSecondary}
          />
        </AdditionalOptionsTextAndArrowIconContainer>
        <Seperator />
      </AdditionalOptionsHeaderRow>
      {showAdditionalOptions && (
        <Text fontSize='14px' color={colors.textSecondary} style={{ marginTop: '-8px' }}>Any items checked below will be active when adding this exercise to a workout</Text>
      )}
      <AdditionalOptionsWrapper showAdditionalOptions={showAdditionalOptions}>
        <LabelAndCheckBoxContainerWrapper showAdditionalOptions={showAdditionalOptions}>
          {/* <Text fontWeight={700} fontSize='16px' color={modalData?.disabledEditModal && colors.textTertiary}>Athlete Input</Text> */}
          <CheckBoxRow>
            {AthleteInputCheckBoxDataArray.map((option) => (
              <NameAndInputContainer disabled={modalData?.disabledEditModal}>
                <input
                  disabled={modalData?.disabledEditModal}
                  className='checkbox-input'
                  type='checkbox'
                  name={option.name}
                  onChange={() => {
                    setFieldValue(`${option.name}`, !option.checked);
                  }}
                  checked={option.checked}
                />
                <Text color={modalData?.disabledEditModal && colors.textTertiary} fontSize='16px' style={{ whiteSpace: 'nowrap ' }}>{option.label}</Text>
              </NameAndInputContainer>
            ))}
          </CheckBoxRow>
        </LabelAndCheckBoxContainerWrapper>
      </AdditionalOptionsWrapper>
    </CircuitsInputsContainer>
  );
};

export default CircuitsFormInputs;
